import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonContent,
  IonList,
  IonItem,
  IonRadioGroup,
  IonListHeader,
  IonLabel,
  IonRadio,
  IonInput,
  IonSelect,
  IonSelectOption,
  IonCol,
  IonGrid,
  IonRow,
  IonCard,
  IonCardContent,
  IonIcon,
  IonModal,
  IonTextarea,
  IonCardHeader,
  IonCardTitle,
} from "@ionic/react";
import { trash } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { AppHeader } from "../../../components/Header/AppHeader";
import Spacer from "../../../components/spacer";
import { toast } from "../../../components/Toast/toast";
import { changeUserPassword, setCurrentView } from "../../../services/users";
import { addUser, updateUser } from "../../../services/users";
import { getDateStamp, toLocalDateString } from "../../../services/util";
import UserHeader from "./components/UserHeader";

export interface RouteParams {
  id: string;
}

interface props {
  usersData: any;
  userDetails: any;
  setCurrentView: any;
}

export const AddEditUser: React.FC<props> = ({
  usersData,
  userDetails,
  setCurrentView,
}) => {
  let { id } = useParams<RouteParams>();

  const phaseInit = {
    pLabel: "",
    pStart: "",
    pEnd: "",
    pOrder: "",
    pNote: "",
    pDisplayNotes: true,
    pDeletable: true,
    pID: "_" + Math.random().toString(36).substr(2, 9),
    pError: "",
  };

  const defaultState = {
    displayName: "",
    email: "",
    username: "",
    lead: "",
    study: "",
    role: "participant",
    phases: [
      {
        pLabel: "Initial Assessment",
        pType: "initial",
        pStart: "",
        pEnd: "",
        pOrder: 0,
        pNote: "",
        pDisplayNotes: false,
        pDeletable: false,
        pID: "_" + Math.random().toString(36).substr(2, 9),
        pError: "",
      },
      {
        pLabel: "Baseline",
        pType: "baseline",
        pStart: "",
        pEnd: "",
        pOrder: 1,
        pNote: "",
        pDisplayNotes: false,
        pDeletable: false,
        pID: "_" + Math.random().toString(36).substr(2, 9),
        pError: "",
      },
      {
        pLabel: "Treatment Phase 1",
        pType: "treatment",
        pStart: "",
        pEnd: "",
        pOrder: 2,
        pNote: "",
        pDisplayNotes: true,
        pDeletable: false,
        pID: "_" + Math.random().toString(36).substr(2, 9),
        pError: "",
      },
      {
        pLabel: "Treatment Phase 2",
        pType: "treatment",
        pStart: "",
        pEnd: "",
        pOrder: 3,
        pNote: "",
        pDisplayNotes: true,
        pDeletable: false,
        pID: "_" + Math.random().toString(36).substr(2, 9),
        pError: "",
      },
      {
        pLabel: "Short-term Follow Up",
        pType: "followup",
        pStart: "",
        pEnd: "",
        pOrder: 9998,
        pNote: "",
        pDisplayNotes: false,
        pDeletable: false,
        pID: "_" + Math.random().toString(36).substr(2, 9),
        pError: "",
      },
      {
        pLabel: "Long-term Follow Up",
        pType: "followup",
        pStart: "",
        pEnd: "",
        pOrder: 9999,
        pNote: "",
        pDisplayNotes: false,
        pDeletable: false,
        pID: "_" + Math.random().toString(36).substr(2, 9),
        pError: "",
      },
    ],
  };

  const history = useHistory();
  const [user, setUser] = useState<any>(defaultState);
  const [users, setUsers] = useState<any>({});
  const [admins, setAdmins] = useState<any>({});
  const [study, setStudy] = useState<any>("sleep");
  const [lead, setLead] = useState<any>("");
  const [errors, setErrors] = useState<any>({});
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  //const [confirmDelete, setConfirmDelete] = useState<boolean>(false);
  const [PWDialog, setPWDialog] = useState<boolean>(false);
  //const [userModified, setUserModified] = useState<boolean>(false);
  const [dates, setDates] = useState<any>([]);

  const { displayName, email, username, password, role } = user;

  useEffect(() => {
    if (usersData) {
      setUsers(usersData);

      if (usersData[id]) {
        setCurrentView(id);
        //console.log(usersData[id]);
        // console.log({ ...defaultState });
        setUser({ ...defaultState, ...usersData[id] });
        setStudy(usersData[id].study);
        setLead(usersData[id].lead);
      }
      let adminUsers = Object.values(usersData).filter(
        (user: any) => user.isAdmin
      );
      setAdmins(adminUsers);
    }
    //eslint-disable-next-line
  }, [usersData]);

  const _checkUsername = (username: any) => {
    let res = true;

    Object.values(users).forEach((user: any) => {
      if (user.username === username && user.id !== id) {
        res = false;
      }
    });

    return res;
  };

  // useEffect(() => {
  // 	if (user) {
  // 		console.log(user);
  // 	}
  // }, [user]);

  const _generateUsername = (initials: any) => {
    //initials = initials.toUpperCase();
    //const checkedName = _checkUsername(username);
    if (id === "new") {
      let username = initials;
      let i = 1;
      while (!_checkUsername(username)) {
        username = initials + i;
        i++;
      }
      return username;
    } else {
      return username;
    }
  };

  const _onChange = (e: any) => {
    let field = e.target.name;
    let value = e.target.value;
    if (
      ["pLabel", "pStart", "pEnd", "pNote", "pvalue", "pID"].includes(
        e.target.name
      )
    ) {
      let phases = user.phases;
      phases[e.target.dataset.id][e.target.name] = e.target.value;
      if (
        phases[e.target.dataset.id].pStart >= phases[e.target.dataset.id].pEnd
      ) {
        phases[e.target.dataset.id].pError =
          "End date must be greater than start date";
        setErrors({
          ...errors,
          phases: "End date must be greater than start date",
        });
      } else {
        phases[e.target.dataset.id].pError = "";
        //check all phases to see if they're in error state
        let phaseError = "";
        Object.values(phases).forEach((phase: any) => {
          if (phase.pStart >= phase.pEnd)
            phaseError = "End date must be greater than start date";
        });

        setErrors({
          ...errors,
          phases: phaseError,
        });
      }
      setUser({ ...user, phases });
      updateDates(phases);
      // }
    } else if (field === "displayName" && role === "participant") {
      let initials = value.toUpperCase();
      let username = _generateUsername(initials);
      setUser({ ...user, displayName: initials, username: username });
    } else setUser({ ...user, [field]: value });
  };

  const updateDates = (phases: any) => {
    const options: any = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    const dayMS = 86400000;

    let response: any = [];

    Object.values(user.phases).forEach((element: any, idx: any) => {
      let startTS = Date.parse(element.pStart + "T00:00:00");
      let endTS = new Date(element.pEnd).getTime();

      let TS = startTS;
      let phase = element.pID;
      let pType =
        element.pType && element.pType !== ""
          ? element.pType
          : defaultState.phases[idx].pType;

      while (TS <= endTS) {
        // if (pType === "followup") debugger;
        let day = new Date(TS);
        if (TS !== startTS) {
          //Conversion only matters if we're crossing the daylight savings boundary
          let todayTimeDiff = day.getTimezoneOffset();
          let diffYesterday = new Date(TS - dayMS).getTimezoneOffset();

          if (diffYesterday !== todayTimeDiff) {
            if (diffYesterday < todayTimeDiff) {
              //Moving to NZST (Spring)
              day.setHours(day.getHours() + 1);
              TS += 3600000;
            } else if (diffYesterday > todayTimeDiff) {
              //Moving to NZDT (Spring)
              day.setHours(day.getHours() - 1);
              TS -= 3600000;
            }
          }
        }

        let date = getDateStamp(day);
        let dateString = day.toLocaleDateString("en-NZ", options);
        let dateField = toLocalDateString(day);

        //console.log(dateField);
        // let status = "upcoming";
        // let link = "upcoming";
        //Add another condition here to check if an entry exists for the date and add a link
        // if (date <= today) {
        // 	status = "overdue";
        // 	link = "new";
        // }

        response.push({
          timestamp: TS,
          dateField,
          dateString,
          date,
          phase,
          pType,
        });
        TS = TS + dayMS;
      }
    });

    setDates(response);
  };

  useEffect(() => {
    if (user.phases) {
      updateDates(user.phases);
    }
    // console.log(user);
    //eslint-disable-next-line
  }, [user]);

  // useEffect(() => {
  // 	setUserModified(false);
  // }, []);

  const _generatePassword = () => {
    var pwdChars =
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz@!#$%^&*";
    var pwdLen = 10;
    var randPassword = Array(pwdLen)
      .fill(pwdChars)
      .map(function (x) {
        return x[Math.floor(Math.random() * x.length)];
      })
      .join("");

    setUser({ ...user, password: randPassword });
  };

  const _checkValid = () => {
    let errs: any = [];
    if (displayName === "") {
      errs.push("Please enter username");
    }
    if (!id && !password) {
      errs.push("Please enter a password");
    }
    if (!id && password.length < 8) {
      errs.push("The password must be at least 8 characters");
    }
    if (role === "participant" && lead === "") {
      errs.push("Please select a lead");
    }

    setErrors(errs);

    return Object.values(errs).length === 0;
  };

  const _onSubmit = () => {
    setDisableSubmit(true);
    let stepValid = _checkValid();

    if (stepValid) {
      //console.log(dates);
      //console.log("add user");
      let userData = {
        displayName,
        lead,
        study,
        username,
        role,
        phases: user.phases,
        dates: dates,
      };
      let uname = username;

      if (role === "admin") {
        userData = {
          displayName,
          lead: "",
          study: "",
          username: email,
          role,
          phases: [],
          dates: [],
        };
        uname = email;
      }

      if (id === "new") {
        //console.log(uname);
        addUser(userData, { uname, password }).then((res: any) => {
          if (res) {
            toast("User created");
            history.push(`/users/`);
          }
        });
      } else {
        updateUser({ ...user, uid: id }, userData);
        //setUserModified(true);
        toast("User updated");
      }
    }

    //setUser(defaultState);
    setDisableSubmit(false);
  };

  const _compareStudy = (o1: any, o2: any) => {
    return o1 === study;
  };

  const _compareLead = (o1: any, o2: any) => {
    return o1 === lead;
  };

  const _onSelect = (e: any) => {
    if (e.target.name === "study") setStudy(e.target.value);
    else if (e.target.name === "lead") setLead(e.target.value);
  };

  const _onRadio = (option: any, value: any) => {
    setUser({ ...user, [option]: value });
  };

  const _addPhase = (e: any) => {
    let phases = user.phases;
    let length = phases.length;
    phases.push({
      ...phaseInit,
      pOrder: length,
      pLabel: `Treatment Phase ${length - 3}`,
      pType: "treatment",
    });
    setUser({ ...user, phases });
  };

  const _removePhase = (i: number) => {
    let phases = user.phases;
    phases.splice(i, 1);
    setUser({ ...user, phases });
  };

  const _back = () => {
    history.push("/users");
  };

  // const _onConfirmationDismiss = () => {
  // 	console.log("dismiss");
  // 	setConfirmDelete(false);
  // };

  // const _delete = () => {
  // 	console.log("confirmed");
  // 	deleteUser(id).then((res: any) => {
  // 		if (res) history.push(`/users`);
  // 	});

  // 	// deleteActivation(id).then(() => {
  // 	// 	getActivations();
  // 	// 	history.push(`/admin/activations`);
  // 	// });
  // };

  const _onPWChange = () => {
    //console.log("password change, ", password);
    if (password.length >= 8) {
      changeUserPassword(id, password).then((res: any) => {
        if (res) {
          setUser({ ...user, password: "" });
          _onPWChangeDismiss();
        }
      });
    } else {
      setErrors({
        ...errors,
        password: "The password must be at least 8 characters",
      });
      //add error message
    }
  };

  const _onPWChangeDismiss = () => {
    //console.log("password dismiss");
    setPWDialog(false);
  };

  const _sortPhases = (a: any, b: any) => {
    return a.pOrder - b.pOrder;
  };

  return (
    <>
      <AppHeader
        title={
          id === "new"
            ? "Add User"
            : displayName.length > 0
            ? `Edit ${displayName}`
            : "Edit User"
        }
      />

      <IonContent fullscreen className="ion-padding">
        <UserHeader user={user} isAdmin={userDetails.isAdmin} />

        <div className="content-wrapper">
          {userDetails.isAdmin && (
            <>
              <IonModal
                isOpen={PWDialog}
                onDidDismiss={_onPWChangeDismiss}
                cssClass="password-modal"
              >
                <IonHeader>
                  <IonToolbar>
                    <IonTitle>Change User Password</IonTitle>
                    <IonButtons slot="end">
                      <IonButton onClick={_onPWChangeDismiss}>Cancel</IonButton>
                    </IonButtons>
                  </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                  <IonList lines="none">
                    <IonItem>
                      <p>Enter the new password below.</p>
                    </IonItem>
                    <IonItem>
                      <IonLabel position="floating">New Password</IonLabel>
                      <IonInput
                        name="password"
                        value={password}
                        onIonChange={_onChange}
                      ></IonInput>
                      <IonButton onClick={_generatePassword} slot="end">
                        Generate
                      </IonButton>
                    </IonItem>
                    <IonItem>
                      {errors.password && (
                        <p className="field_error_message">{errors.password}</p>
                      )}
                    </IonItem>
                    <IonItem>
                      <IonButton size="default" onClick={() => _onPWChange()}>
                        Save Password
                      </IonButton>
                    </IonItem>
                  </IonList>
                </IonContent>
                {/* <IonFooter>
						<IonGrid>
							<IonRow>
								<IonCol>
									<IonButtons>
										<IonButton onClick={_onPWChangeDismiss}>Cancel</IonButton>
									</IonButtons>
								</IonCol>
							</IonRow>
						</IonGrid>
					</IonFooter> */}
              </IonModal>
              {/* <ConfirmationDialog
								showAlert={confirmDelete}
								header={"Warning"}
								subHeader={"You are about to permanently delete this user"}
								message={"Are you sure? Click OK to continue"}
								callback={_delete}
								dismissCallback={_onConfirmationDismiss}
							/> */}
              <div className="container">
                <IonList>
                  {id === "new" && (
                    <IonItem lines="none">
                      <IonList lines="none">
                        <IonRadioGroup
                          value={role}
                          onChange={_onChange}
                          id="role"
                          name="role"
                        >
                          <IonListHeader>
                            <IonLabel>User Role</IonLabel>
                          </IonListHeader>

                          <IonItem>
                            <IonLabel>Participant</IonLabel>
                            <IonRadio
                              slot="start"
                              value="participant"
                              onClick={() => _onRadio("role", "participant")}
                            />
                          </IonItem>
                          <IonItem>
                            <IonLabel>Admin</IonLabel>
                            <IonRadio
                              slot="start"
                              value="admin"
                              onClick={() => _onRadio("role", "admin")}
                            />
                          </IonItem>
                        </IonRadioGroup>
                      </IonList>
                    </IonItem>
                  )}
                  <Spacer size="30" />
                  {role === "admin" && (
                    <>
                      <IonItem>
                        <IonLabel position="floating">Display Name</IonLabel>
                        <IonInput
                          name="displayName"
                          value={displayName}
                          onIonChange={_onChange}
                        ></IonInput>
                      </IonItem>

                      <IonItem>
                        <IonLabel position="floating">Email</IonLabel>
                        <IonInput
                          name="email"
                          value={email}
                          onIonChange={_onChange}
                          disabled={id !== "new"}
                        ></IonInput>
                      </IonItem>
                    </>
                  )}
                  {role === "participant" && (
                    <>
                      <IonItem>
                        <IonLabel position="floating">
                          Participant Initials
                        </IonLabel>
                        <IonInput
                          name="displayName"
                          value={displayName}
                          onIonChange={_onChange}
                        ></IonInput>
                      </IonItem>
                      <IonItem>
                        <IonLabel position="floating">Username</IonLabel>
                        <IonInput
                          name="username"
                          disabled
                          value={username}
                        ></IonInput>
                      </IonItem>
                    </>
                  )}
                  <Spacer size="30" />
                  {id === "new" && (
                    <IonItem>
                      <IonLabel position="floating">Password</IonLabel>
                      <IonInput
                        name="password"
                        value={password}
                        onIonChange={_onChange}
                      ></IonInput>
                      <IonButton onClick={_generatePassword} slot="end">
                        Generate
                      </IonButton>
                    </IonItem>
                  )}
                  {id !== "new" && (
                    <IonButton onClick={() => setPWDialog(true)}>
                      Change Password
                    </IonButton>
                  )}
                  <Spacer size="30" />
                  {role === "participant" && (
                    <>
                      <IonItem>
                        <IonLabel position="floating">Study</IonLabel>
                        <IonSelect
                          compareWith={_compareStudy}
                          value={study}
                          name="study"
                          onIonChange={_onSelect}
                          okText="Okay"
                          cancelText="Dismiss"
                          placeholder="Select One"
                          interface="popover"
                        >
                          <IonSelectOption value="sleep">
                            Sleeping
                          </IonSelectOption>
                          <IonSelectOption value="eat">Eating</IonSelectOption>
                          <IonSelectOption value="toilet">
                            Toileting
                          </IonSelectOption>
                        </IonSelect>
                      </IonItem>
                      <Spacer size="30" />
                      <IonItem>
                        <IonLabel position="floating">Lead</IonLabel>
                        <IonSelect
                          compareWith={_compareLead}
                          value={lead}
                          name="lead"
                          onIonChange={_onSelect}
                          okText="Okay"
                          cancelText="Dismiss"
                          placeholder="Select One"
                          interface="popover"
                        >
                          {admins &&
                            admins.length > 0 &&
                            admins.map((admin: any, idx: any) => (
                              <IonSelectOption key={idx} value={admin.id}>
                                {admin.displayName}
                              </IonSelectOption>
                            ))}
                        </IonSelect>
                      </IonItem>
                    </>
                  )}
                  <Spacer size="60" />
                  {role === "participant" && (
                    <>
                      <h2>Phases</h2>
                      <IonItem lines="none">
                        <IonList className="full-width">
                          {Object.values(user.phases.sort(_sortPhases)).map(
                            (option: any, idx: any) => {
                              //console.log(idx);
                              let pStartId = `pStart-${idx}`,
                                pEndId = `pEnd-${idx}`,
                                pNoteId = `pNote-${idx}`,
                                optionId = `option-${idx}`;
                              return (
                                <div key={idx}>
                                  <IonCard className="repeater-card">
                                    <IonCardHeader>
                                      <IonItem lines="none">
                                        <IonCardTitle>
                                          {user.phases[`${idx}`].pLabel}
                                        </IonCardTitle>
                                        {user.phases[`${idx}`].pDeletable && (
                                          <IonIcon
                                            slot="end"
                                            onClick={() => _removePhase(idx)}
                                            icon={trash}
                                            className="trash linked"
                                          />
                                        )}
                                      </IonItem>
                                    </IonCardHeader>
                                    <IonCardContent>
                                      <IonGrid>
                                        <IonRow>
                                          <IonCol>
                                            <IonGrid>
                                              <IonRow>
                                                <IonCol>
                                                  <IonItem className="no-padding">
                                                    <IonLabel position="stacked">
                                                      Start Date
                                                    </IonLabel>
                                                    <IonInput
                                                      type="date"
                                                      id={pStartId}
                                                      name="pStart"
                                                      data-id={`${idx}`}
                                                      value={
                                                        user.phases[`${idx}`]
                                                          .pStart
                                                      }
                                                      onIonChange={_onChange}
                                                    ></IonInput>
                                                  </IonItem>
                                                </IonCol>
                                                <IonCol>
                                                  <IonItem className="no-padding">
                                                    <IonLabel position="stacked">
                                                      End Date
                                                    </IonLabel>
                                                    <IonInput
                                                      type="date"
                                                      id={pEndId}
                                                      name="pEnd"
                                                      data-id={`${idx}`}
                                                      value={
                                                        user.phases[`${idx}`]
                                                          .pEnd
                                                      }
                                                      onIonChange={_onChange}
                                                    ></IonInput>
                                                  </IonItem>
                                                  <IonInput
                                                    type="text"
                                                    id={optionId}
                                                    name="pID"
                                                    data-id={`${idx}`}
                                                    value={
                                                      user.phases[`${idx}`].pID
                                                    }
                                                    readonly
                                                    hidden
                                                    onIonChange={_onChange}
                                                  ></IonInput>
                                                </IonCol>
                                              </IonRow>
                                              {user.phases[`${idx}`]
                                                .pDisplayNotes && (
                                                <IonRow>
                                                  <IonCol>
                                                    <IonItem className="no-padding">
                                                      <IonLabel position="floating">
                                                        Notes
                                                      </IonLabel>
                                                      <IonTextarea
                                                        id={pNoteId}
                                                        name="pNote"
                                                        data-id={`${idx}`}
                                                        value={
                                                          user.phases[`${idx}`]
                                                            .pNote
                                                        }
                                                        onIonChange={_onChange}
                                                      />
                                                    </IonItem>
                                                  </IonCol>
                                                </IonRow>
                                              )}
                                              {user.phases[`${idx}`].pError && (
                                                <IonRow>
                                                  <IonCol>
                                                    <IonCard color="danger">
                                                      <IonCardContent>
                                                        <div id="errors">
                                                          {
                                                            user.phases[
                                                              `${idx}`
                                                            ].pError
                                                          }
                                                        </div>
                                                      </IonCardContent>
                                                    </IonCard>
                                                  </IonCol>
                                                </IonRow>
                                              )}
                                            </IonGrid>
                                          </IonCol>
                                        </IonRow>
                                      </IonGrid>
                                    </IonCardContent>
                                  </IonCard>
                                </div>
                              );
                            }
                          )}
                          <Spacer size="30" />
                          <IonItem lines="none">
                            <IonButton size="default" onClick={_addPhase}>
                              Add phase
                            </IonButton>
                          </IonItem>
                        </IonList>
                      </IonItem>
                    </>
                  )}
                </IonList>
              </div>
              <Spacer size="60" />
              {Object.values(errors).length > 0 &&
                !(
                  Object.values(errors).length === 1 && errors.phases === ""
                ) && (
                  <IonCard color="danger">
                    <IonCardContent>
                      <div id="errors">
                        {Object.values(errors).map((error: any, idx: any) => (
                          <div key={idx}>{error}</div>
                        ))}
                      </div>
                    </IonCardContent>
                  </IonCard>
                )}
              <IonToolbar>
                <IonButtons>
                  <IonButton
                    color="success"
                    onClick={_onSubmit}
                    disabled={disableSubmit}
                  >
                    Save
                  </IonButton>
                  <IonButton onClick={_back} color="warning">
                    Close
                  </IonButton>
                </IonButtons>
                {/* <IonButtons slot="end">
									<IonButton
										onClick={() => setConfirmDelete(true)}
										color="danger"
									>
										<IonIcon icon={trash} slot="start"></IonIcon>
										Delete
									</IonButton>
								</IonButtons> */}
              </IonToolbar>
              <Spacer size="90" />
            </>
          )}
          {!userDetails.isAdmin && (
            <span>You do not have permission to view this page</span>
          )}
        </div>
      </IonContent>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  userDetails: state.user.userDetails,
  usersData: state.user.users,
});

const mapDispatchToProps = { setCurrentView };

export default connect(mapStateToProps, mapDispatchToProps)(AddEditUser);
